import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z",
    fill: "#111827"
  })
], -1)

import { watch, ref, onMounted, computed } from "vue";
import DashboardSidebar from '../components/Sidebars/DashboardSidebar.vue' ;
import DashboardHeader from '../components/Headers/DashboardHeader.vue' ;
import DashboardFooter from '../components/Footers/DashboardFooter.vue' ;
import DashboardSettingsDrawer from '../components/Sidebars/DashboardSettingsDrawer.vue' ;
import { useRouter, useRoute } from "vue-router";
import cookiesConFig from "@/utils/CookiesConfig";
import {
  DARK_TYPE,
  SIDEBAR_COLOR,
  SIDEBAR_THEME,
  NAVBAR_FIXED,
  SHOW_SETTINGS_DRAWER,
} from "@/const/ConstCookies";
import store from '@/store/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardRTL',
  setup(__props) {

const route = useRoute();
const sidebarCollapsed = ref(false);
const sidebarColor = ref("primary");
const sidebarTheme = ref("dark");
const navbarFixed = ref(false);
const showSettingsDrawer = ref(false);
const darkType = ref("");
// const layoutClass = computed(() => {
//   return route.meta.layoutClass;
// });
const layoutClass =  ref('default');
const isLayoutClass = computed(() => {
    return store.getters.isLayoutClass
})

watch(isLayoutClass, async (newValue, oldValue) => {
  layoutClass.value = newValue
  if(newValue == null || newValue == '') {
    layoutClass.value = 'default'
  } else {
    layoutClass.value = newValue
  }
})

onMounted(() => {
  modelConfig();
});
const toggleSidebar = (val: any) => {
  sidebarCollapsed.value = val;
};

const toggleSettingsDrawer = (val: any) => {
  cookiesConFig.setCokies(SHOW_SETTINGS_DRAWER, val);
  showSettingsDrawer.value = val;
};

const toggleNavbarPosition = (val: any) => {
  cookiesConFig.setCokies(NAVBAR_FIXED, val);
  navbarFixed.value = val;
};

const updateSidebarTheme = (val: any) => {
  cookiesConFig.setCokies(SIDEBAR_THEME, val);
  sidebarTheme.value = val;
};

const updateSidebarColor = (val: any) => {
  cookiesConFig.setCokies(SIDEBAR_COLOR, val);
  sidebarColor.value = val;
};
const darkModel = (val: any) => {
  cookiesConFig.setCokies(DARK_TYPE, val);
  darkType.value = val;
};

const modelConfig = () => {
  sidebarColor.value = cookiesConFig.getCokies(SIDEBAR_COLOR);
  sidebarTheme.value = cookiesConFig.getCokies(SIDEBAR_THEME);
  navbarFixed.value = cookiesConFig.getCokiesBoolean(NAVBAR_FIXED);
  showSettingsDrawer.value = cookiesConFig.getCokiesBoolean(SHOW_SETTINGS_DRAWER);
  darkType.value = cookiesConFig.getCokies(DARK_TYPE);
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_layout, {
      class: _normalizeClass(["layout-dashboard layout-dashboard-rtl", [navbarFixed.value ? 'navbar-fixed' : '', ! sidebarCollapsed.value ? 'has-sidebar' : '', _unref(route).meta.layoutClass]]),
      id: "layout-dashboard"
    }, {
      default: _withCtx(() => [
        _createVNode(DashboardSettingsDrawer, {
          showSettingsDrawer: showSettingsDrawer.value,
          navbarFixed: navbarFixed.value,
          sidebarTheme: sidebarTheme.value,
          rtl: true,
          onToggleSettingsDrawer: toggleSettingsDrawer,
          onToggleNavbarPosition: toggleNavbarPosition,
          onUpdateSidebarTheme: updateSidebarTheme,
          onUpdateSidebarColor: updateSidebarColor
        }, null, 8, ["showSettingsDrawer", "navbarFixed", "sidebarTheme"]),
        _createVNode(DashboardSidebar, {
          sidebarCollapsed: sidebarCollapsed.value,
          sidebarColor: sidebarColor.value,
          sidebarTheme: sidebarTheme.value,
          onToggleSidebar: toggleSidebar
        }, null, 8, ["sidebarCollapsed", "sidebarColor", "sidebarTheme"]),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(DashboardHeader, {
              sidebarCollapsed: sidebarCollapsed.value,
              navbarFixed: navbarFixed.value,
              onToggleSettingsDrawer: toggleSettingsDrawer,
              onToggleSidebar: toggleSidebar
            }, null, 8, ["sidebarCollapsed", "navbarFixed"]),
            _createVNode(_component_a_layout_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            }),
            _createVNode(DashboardFooter),
            _withDirectives(_createElementVNode("div", {
              class: "sidebar-overlay",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarCollapsed.value = true))
            }, null, 512), [
              [_vShow, ! sidebarCollapsed.value]
            ]),
            _createVNode(_component_a_button, {
              class: "fab",
              shape: "circle",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showSettingsDrawer.value = true))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})